import { createContext, useState } from 'react';

import { AlertMessageTypes } from '../components/AlertMessage/AlertMessage';

import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CampaignIcon from '@mui/icons-material/Campaign';

export const UIContext = createContext();

function UIContextProvider(props) {
  const [selectedBottomMenuOption, setSelectedBottomMenuOption] = useState(0);
  const [infoDialogue, setOpenInfoDialogue] = useState(null);
  const [alert, setShowAlertMessage] = useState(null);

  // Info dialogues
  const OK_LABEL = "OK";
  const INFO_DIALOGUE_MSGS = {
    DENOUNCE_HAS_BEEN_UPDATED: 1,
    SUBMITTED_USER_CODE: 2,
    VECTOR_FOCUS_HAS_BEEN_CREATED: 3,
    VECTOR_FOCUS_HAS_BEEN_UPDATED: 4,
    VECTOR_FOCUS_ADDRESS_HAS_BEEN_UPDATED: 5,
    LOCATION_IS_REQUIRED_TO_USE_THIS_FEATURE: 6
  };
  const infoDialogueMsgs = {
    [INFO_DIALOGUE_MSGS.DENOUNCE_HAS_BEEN_UPDATED]: {
      title: "",
      confirmLabel: OK_LABEL,
      content: (
        <div className="dialogue-content">
          <CampaignIcon className="icon"/>
          <p>A denúncia foi atualizada! Obrigado.</p>
        </div>
      )
    },
    [INFO_DIALOGUE_MSGS.SUBMITTED_USER_CODE]: {
      title: "",
      confirmLabel: OK_LABEL,
      content: (
        <div className="dialogue-content">
          <FavoriteIcon className="icon"/>
          <p>Tudo certo! Obrigado :)</p>
        </div>
      )
    },
    [INFO_DIALOGUE_MSGS.VECTOR_FOCUS_HAS_BEEN_CREATED]: {
      title: "",
      confirmLabel: OK_LABEL,
      content: (
        <div className="dialogue-content">
          <ImageSearchIcon className="icon"/>
          <p>O novo foco foi registrado! Obrigado :)</p>
        </div>
      )
    },
    [INFO_DIALOGUE_MSGS.VECTOR_FOCUS_HAS_BEEN_UPDATED]: {
      title: "",
      confirmLabel: OK_LABEL,
      content: (
        <div className="dialogue-content">
          <ImageSearchIcon className="icon"/>
          <p>O novo foco foi atualizado! Obrigado :)</p>
        </div>
      )
    },
    [INFO_DIALOGUE_MSGS.VECTOR_FOCUS_ADDRESS_HAS_BEEN_UPDATED]: {
      title: "",
      confirmLabel: OK_LABEL,
      content: (
        <div className="dialogue-content">
          <CheckCircleOutlineIcon className="icon"/>
          <p>O endereço do foco foi atualizado! Obrigado :)</p>
        </div>
      )
    },
    [INFO_DIALOGUE_MSGS.LOCATION_IS_REQUIRED_TO_USE_THIS_FEATURE]: {
      title: "Atenção",
      confirmLabel: OK_LABEL,
      content: (
        <div className="dialogue-content">
          <GpsFixedIcon className="icon"/>
          <p>Precisamos acessar sua localização para utilizar esta funcionalidade.</p>
        </div>
      )
    }
  };
  const openInfoDialogue = !!infoDialogue?.open;
  const infoMsgTitle = infoDialogueMsgs[infoDialogue?.msgId]?.title;
  const infoMsgLabel = infoDialogueMsgs[infoDialogue?.msgId]?.confirmLabel;
  const infoMsgContent = infoDialogueMsgs[infoDialogue?.msgId]?.content;

  function handleCloseInfoDialogue () {
    infoDialogue?.callback?.();
    setOpenInfoDialogue({
      open: false,
      msg: null,
      callback: null
    });
  }
  
  // Alert messages
  const showAlertMessage = !!alert?.show;
  const alertMessageType = alert?.alertMessageType;
  const alertMessageTitle = alert?.alertMessageTitle;
  const alertMessage = alert?.alertMessage;

  function handleCloseAlertMessage() {
    alert?.callback?.();
    setShowAlertMessage({
      show: false,
      alertMessageType: AlertMessageTypes.INFO,
      alertMessageTitle: "",
      alertMessage: ""
    });
  }

  function showWarningMessage({message}) {
    setShowAlertMessage({
      show: true,
      alertMessageType: AlertMessageTypes.WARNING,
      alertMessageTitle: "Atenção",
      alertMessage: message
    });
  }

  function showErrorMessage({message}) {
    setShowAlertMessage({
      show: true,
      alertMessageType: AlertMessageTypes.ERROR,
      alertMessageTitle: "Erro",
      alertMessage: message
    });
  }

  function showInfoMessage({message}) {
    setShowAlertMessage({
      show: true,
      alertMessageType: AlertMessageTypes.INFO,
      alertMessageTitle: "",
      alertMessage: message
    });
  }

  function showSuccessMessage({message}) {
    setShowAlertMessage({
      show: true,
      alertMessageType: AlertMessageTypes.SUCCESS,
      alertMessageTitle: "",
      alertMessage: message
    });
  }

  // Output
  return (
    <UIContext.Provider value={{
      selectedBottomMenuOption,
      setSelectedBottomMenuOption,
      setOpenInfoDialogue,
      handleCloseInfoDialogue,
      showWarningMessage,
      showErrorMessage,
      showInfoMessage,
      showSuccessMessage,
      handleCloseAlertMessage,

      INFO_DIALOGUE_MSGS,
      openInfoDialogue,
      infoMsgTitle,
      infoMsgLabel,
      infoMsgContent,

      showAlertMessage,
      alertMessageType,
      alertMessageTitle,
      alertMessage
    }}>
      {props.children}
    </UIContext.Provider>
  );
}

export default UIContextProvider;
